/**
 * @file Web Gallery Header Cart.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CartIcon from '../../../components/icons/CartIcon';

const propTypes = {
  className: PropTypes.string,
  displayTextClassName: PropTypes.string,
  totalCartItems: PropTypes.number,
  iconId: PropTypes.string,
  checkout: PropTypes.func.isRequired,
  displayText: PropTypes.string,
  cartColor: PropTypes.string,
  children: PropTypes.func,
};

const WebGalleryHeaderCart = ({
  className,
  displayTextClassName = 'ml-2',
  totalCartItems = 0,
  iconId = 'wg-cart-icon',
  checkout,
  displayText = '',
  cartColor,
  children,
}) => {
  const classes = classNames({
    'd-flex': true,
    'cart-header-btn': true,
    'btn-reset': true,
    [className]: !!className,
  });

  if (totalCartItems === 0) {
    return null;
  }

  if (typeof children === 'function') {
    return children({ checkout });
  }

  return (
    <button onClick={checkout} className={classes}>
      <div className="cart-header-icon">
        <CartIcon id={iconId} color={cartColor || undefined} />
        <span className="cart-header-icon-items">{totalCartItems}</span>
      </div>

      {displayText && (
        <span
          style={cartColor && { color: cartColor }}
          className={displayTextClassName}
        >
          {displayText}
        </span>
      )}
    </button>
  );
};

WebGalleryHeaderCart.propTypes = propTypes;

export default WebGalleryHeaderCart;
